
/**
 * A Location is part of Realisation record
 *  One Realisation record can hold multiple Locations
 */
class Location {
  constructor({
    data, copy,
  }) {
    let model = {}

    // short circuit making copies
    if (copy || this.LooksAndQuacksLikeCopy({ data })) {
      model = this.makePlainCopy({ data })
    } else {

      model = this.commonStructure({ data })

      /**
       * Tenant specific fields
       */
      model.GridOperator = data.GridOperator || ''
      model.Municipality = data.Municipality || null

      if (!data.TrafficDecision?.PublicationDate) {
        model.TrafficDecision.TrafficDecisionNotApplicable = true
      }
    }

    //
    Object.keys(model).forEach(key => {
      this[key] = model[key]
    })
  }

  LocationCopy({ version }) {
    let oldData = JSON.parse(JSON.stringify(this))

    let data = {
      Location: oldData.Location,
      Remarks: oldData.Remarks,
      ChargePointOperator: oldData.ChargePointOperator,
      GridOperator: oldData.GridOperator,
      ParkingSpots: oldData.ParkingSpots,
      Contractor: oldData.Contractor,
      CPOAdvice: {
        SumAdditionalCost: oldData.CPOAdvice.SumAdditionalCost || '',
        AdditionalCostDescription: oldData.CPOAdvice.AdditionalCostDescription || '',
        AdditionalCostDescriptionContractor: oldData.CPOAdvice.AdditionalCostDescriptionContractor || '',
      },
      LocationPreparation: {
        RequiresLocationPreparation: oldData.LocationPreparation.RequiresLocationPreparation || [],
        OtherReason: oldData.LocationPreparation.OtherReason || '',
      },
      Docs: {
        ParkingSpots: oldData.Docs.ParkingSpots || [],
        // Underground: oldData.Docs.Underground || [],
        CPOAdditional: oldData.Docs.CPOAdditional || [],
      },

      Municipality: oldData.Municipality,
    }

    data.version = version

    return new Location({ data, copy: true })
  }
}

export default Location
